module.exports = __webpack_public_path__ + "static/aop (4)-a7e323935ffefd71f68213eb899ca0fe.jpg";